// Extracts URL parameters
function getUrlVars() {
  var vars = {};
  var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(
    m,
    key,
    value
  ) {
    vars[key] = value;
  });
  return vars;
}


// WEBPACK FOOTER //
// ./source/assets/js/modules/get-url-vars.js